import { Box, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { LegendInner } from "../Legend/BaseLegend.styles";

export const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
});

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(1),
  flexShrink: 0,
  position: "sticky",
  top: 0,
  backgroundColor: "#fff",
  zIndex: 10,
  borderBottom: "1px solid",
  borderBottomColor: theme.palette.divider,
}));

export const HeaderTitle = styled(Typography)({
  fontSize: 12,
  whiteSpace: "nowrap",
  marginRight: 4,
});

export const SearchField = styled(TextField)({
  maxWidth: 170,
  margin: 0,
  "& .MuiOutlinedInput-root": {
    height: 28,
    paddingRight: 0,
  },
  "& .MuiOutlinedInput-input": {
    fontSize: 12,
  },
  "& .MuiInputAdornment-root p": {
    fontSize: 12,
  },
});

export const ItemTitleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  gap: 8,
  maxWidth: 300,
  minWidth: 0,
});

export const ItemTitleContent = styled(Box)({
  flex: 1,
  fontSize: 12,
  minWidth: 0,
  overflow: "hidden",
});

export const ItemTitleContentWithIcon = styled(Box)({
  flex: 1,
  fontSize: 12,
  display: "flex",
  alignItems: "center",
  gap: 4,
  minWidth: 0,
  overflow: "hidden",
});

export const TreeContainer = styled(LegendInner)(({ theme }) => ({
  flexGrow: 1,
  minHeight: 0,
  overflow: "auto",
  "& .rct-tree-item-title-GROUP": {
    color: theme.palette.biarri.primary.red,
  },
}));
